import EVSETable from "./EVSETable";

const EVSETab = () => {
	return <EVSETable />;
};

export default EVSETab;
